import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import "./AIPlatformHeroFeatures.css";

export default function AIPlatformHeroFeatures({
  features,
  activeFeatureId,
  onFeatureSelect,
}) {
  const { t } = useTranslation();
  const activeFeature = useMemo(
    () =>
      features.find((feature) => feature.id === activeFeatureId) ??
      features[0] ??
      { label: "", description: "", signals: [] },
    [features, activeFeatureId]
  );

  return (
    <div className="ai-platform-hero-features">
      <svg
        className="ai-platform-hero-features__links"
        viewBox="0 0 320 240"
        aria-hidden="true"
      >
        <path d="M62 182C105 160 120 124 154 118" />
        <path d="M258 180C218 158 202 126 166 118" />
        <path d="M216 48C196 70 184 88 164 112" />
      </svg>

      {features.map((feature, index) => (
        <button
          key={feature.id}
          type="button"
          className={`ai-platform-hero-node ai-platform-hero-node--${index + 1} ${
            feature.id === activeFeatureId ? "is-active" : ""
          }`}
          onClick={() => onFeatureSelect(feature.id)}
        >
          <span className="ai-platform-hero-node__dot" />
          <span className="ai-platform-hero-node__label">{feature.label}</span>
          <span className="ai-platform-hero-node__hint">{feature.hint}</span>
        </button>
      ))}

      <aside className="ai-platform-hero-panel">
        <span className="ai-platform-hero-panel__kicker">{t("aiPlatform.hero.activeFeature")}</span>
        <strong>{activeFeature.label}</strong>
        <p>{activeFeature.description}</p>
        <div className="ai-platform-hero-panel__chips">
          {activeFeature.signals.map((signal) => (
            <span key={signal}>{signal}</span>
          ))}
        </div>
      </aside>
    </div>
  );
}
